import { DeviceManagementServiceRB } from '../services/deviceManagement/deviceManagement.service';
import { Plugin } from './plugin';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';

export class DeviceManagementPlugin extends Plugin {
    public static initialize(): DeviceManagementPlugin {
        Plugin.initialize();

        if (!window.rainbow.plugins[DeviceManagementPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[DeviceManagementPlugin] initialized");
            window.rainbow.plugins[DeviceManagementPlugin.name] = new DeviceManagementPlugin();
            DeviceManagementServiceRB.getInstance();
        }
        return window.rainbow.plugins[DeviceManagementPlugin.name];
    }

    private constructor() {
        super();
    }
}